<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">获取Model版本号</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			获取SDK所用人脸识别模型的版本号属性。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">+ (NSString *)skFaceGetModelVersion;</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">无</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	字符串，版本号信息
			例如：“V1.1”，表示SKFace-Model-1.1版本。
		</p>
		
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">NSString * modelVersion = [SKFaceManagerInterface skFaceGetModelVersion];</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFace-iOS','SDK版本信息接口','获取Model版本号'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfaceios/sdkedition/getModeVersion.vue